import ErrorPage from './default';
import { EMPTY_CONTACT_MEDIA_ERROR_PAGE_TEXT } from './constants';

function EmptyContactMediaErrorPage(props) {
  return (
    <ErrorPage
      {...props}
      title={EMPTY_CONTACT_MEDIA_ERROR_PAGE_TEXT.TITLE}
      description={EMPTY_CONTACT_MEDIA_ERROR_PAGE_TEXT.DESCRIPTION}
      buttonHref={EMPTY_CONTACT_MEDIA_ERROR_PAGE_TEXT.BUTTON_HREF}
      buttonText={EMPTY_CONTACT_MEDIA_ERROR_PAGE_TEXT.BUTTON_TEXT}
      iconColor="BLUE"
      iconId="informacion"
      showLink={false}
    />
  );
}
export default EmptyContactMediaErrorPage;
